import * as Yup from "yup";

export const Ds160InfoContentValidation = Yup.object().shape({
  email: Yup.string().required("Required").trim(),
});
